'use client';

import { useEffect } from 'react';
import { analytics } from 'libs/segment';

declare global {
  interface Window {
    shouldFireFirstPageEvents?: boolean;
  }
}

export const FirstPageViewedTracker = () => {
  useEffect(() => {
    if (!window.shouldFireFirstPageEvents) {
      return;
    }

    window.shouldFireFirstPageEvents = false;

    const searchParams = new URLSearchParams(window.location.search);
    const url = window.location.href;

    analytics.page('First Page Viewed', {
      referral_campaign_id: null,
      referred_by: null,
      referral_type: null,
      affiliate_name: null,
      ad_id: searchParams.has('ad') || searchParams.has('ad_id') ? searchParams.toString() : null,
      source_url: document.referrer,
      url,
      current_url: url,
      starting_point: 'Landing Page',
      path: window.location.pathname,
    });
  }, []);

  return null;
};
